import React, { useState } from 'react';

import { isPossiblePhoneNumber } from 'react-phone-number-input';

import FormContainer from 'components/LoanForm/FormContainer';
import PhoneNumberInput from 'components/PhoneNumberInput';
import { YourContactVariable } from 'enums/LoanFormVariables';
import styles from 'components/FinancialCheckup/PhoneNumber/YourPhoneNumber.module.scss';
import Button from 'components/Button';
import { PHONE_NUMBER_LENGTH, YourContactInputLabel } from 'components/FinancialCheckup/PhoneNumber/YourPhoneNumber';

export interface EnterPhoneNumberProps {
  onPhoneNumberEntered: (phoneNumber: string) => void;
  isSendBlocked?: boolean;
  warning?: React.ReactNode;
}

export const EnterPhoneNumber = (args: EnterPhoneNumberProps) => {
  const { onPhoneNumberEntered, isSendBlocked = false, warning } = args;
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumberIsValid, setPhoneNumberIsValid] = useState(false);

  const onChange = (value: string) => {
    let newIsValid;
    if (value) {
      if (isPossiblePhoneNumber(value)) {
        setPhoneNumber(value);
        newIsValid = true;
      } else if (isPossiblePhoneNumber(`+${value.substring(2)}`, { defaultCountry: 'AR' })) {
        setPhoneNumber(`+${value.substring(2)}`);
        newIsValid = true;
      } else {
        newIsValid = false;
      }
    } else {
      newIsValid = false;
    }

    setPhoneNumberIsValid(newIsValid);
  };

  return (
    <FormContainer title="Enter your phone number" subtitle="We’ll send a code to verify your number.">
      <PhoneNumberInput
        label={YourContactInputLabel.PhoneNumber}
        placeholder="000-000-0000"
        className={styles.formInput}
        name={YourContactVariable.PhoneNumber}
        onChange={onChange}
        value={phoneNumber}
        maxLength={PHONE_NUMBER_LENGTH}
        country="US"
        disabled={false}
        onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) =>
          e.key === 'Enter' && phoneNumberIsValid && onPhoneNumberEntered(phoneNumber)
        }
        autoFocus
      />
      <Button
        className={styles.button}
        disabled={!phoneNumberIsValid || isSendBlocked}
        onClick={() => onPhoneNumberEntered(phoneNumber)}
      >
        Send Code To My Phone
      </Button>
      {warning}
    </FormContainer>
  );
};
